import { Loader2, Square, Radio } from "lucide-react";
import { api } from "@/lib/api";

const BRIEFINGS = [
  { path: "/home/brief/say", label: "Today's brief", note: "Your plans and the weather today" },
  { path: "/home/week/say", label: "Week ahead", note: "The next seven days, plans and rain" },
  { path: "/home/month/say", label: "Month ahead", note: "How full the next thirty days look" },
];

// Three live briefings — each one is read out fresh when you tap it.
export const BriefHistory = ({ speaker, lang }) => (
  <div className="mt-3 space-y-1.5" data-testid="brief-history">
    <p className="text-[11px] uppercase tracking-widest text-ink-soft">Briefings</p>
    {BRIEFINGS.map((b) => (
      <button
        key={b.path}
        data-testid={`brief-say-${b.path.split("/")[2]}`}
        onClick={() => speaker.play(b.path,
          async () => (await api.get(b.path, { params: { lang } })).data.text)}
        disabled={Boolean(speaker.loading)}
        className="flex w-full items-center gap-2 rounded-2xl border border-white/10 bg-page px-3 py-2 text-start text-xs transition-colors hover:border-brand/40 disabled:opacity-50"
      >
        {speaker.loading === b.path
          ? <Loader2 className="h-3.5 w-3.5 shrink-0 animate-spin text-brand" />
          : speaker.playing === b.path
            ? <Square className="h-3.5 w-3.5 shrink-0 text-brand" />
            : <Radio className="h-3.5 w-3.5 shrink-0 text-brand" />}
        <span className="min-w-0 flex-1 truncate">
          <span className="font-semibold">{b.label}</span>
          {" · "}<span className="text-ink-soft">{speaker.playing === b.path ? "Stop" : b.note}</span>
        </span>
      </button>
    ))}
  </div>
);
